export const routes = [
	{
		name: "Home",
		link: "/",
	},
	{
		name: "Our Company",
		link: "/#",

		subRoutes: [
			{
				name: 'About Us',
				link: '/about',
			},
			{
				name: 'Board of Directors',
				link: '/board',
			},
			{
				name: 'Management Team',
				link: '/executives',
			},
		],
	},
	{
		name: "Our Business",
		link: "/our_business",
	},
	{
		name: 'Download',
		link: '/form_downloads',
	},
	{
		name: "Resources",
		link: "/#",

		subRoutes: [
			{
				name: 'Market Review',
				link: '/market_review',
			},
			{
				name: 'Newsletters',
				link: '/newsletters',
			},
			{
				name: 'Investment Calculator',
				link: '/investment_calculator',
			},
		]
	},
	{
		name: 'Gallery',
		link: '/gallery',
	},
	{
		name: 'Contact Us',
		link: '/contact',
	},
];
